/**
 * Auth lifecycle events.
 *
 * A small event bus so the transport can signal "your session ended" without
 * importing the session module. Without this, `api/` would depend on `app/`,
 * inverting the layering and making the transport untestable in isolation.
 */

export type AuthEvent = 'signed-out' | 'unauthenticated' | 'refresh-failed';

type Listener = (event: AuthEvent) => void;

const listeners = new Set<Listener>();

export function onAuthEvent(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitAuthEvent(event: AuthEvent): void {
  for (const listener of listeners) {
    listener(event);
  }
}

/** Test-only. Leaking listeners between tests causes order-dependent failures. */
export function resetAuthEventListeners(): void {
  listeners.clear();
}